// 设备管理接口
import { $post, $get ,$delete, $patch} from '@/utils/http'
import Service from './Service'

// 接口集合
const _url = {
    // 添加集控器
    ADDCOLLECTOR: `/ucenter/v2/devices/addcollector`,
    // 删除集控器
    DETELECOLLECTOR: `/ucenter/v2/devices/delcollector`,
    // 修改集控器
    EDITCOLLECTOR: `/ucenter/v2/devices/editcollector`,
    // 获取集控器
    GETCOLLECTOR: `/ucenter/v2/devices/listcollector`,

    // 添加表计
    ADDMETER: `/ucenter/v2/devices/addterminal`,
	//添加直连设备表计
	ADDDIRECTLYMETER:"/ucenter/v2/devices/fc226w",
    // 获取集控器下面所有表计
    GETMETER: `/ucenter/v2/devices/listterminal`,
	//获取直连设备表计
	GETDIRECTLYEMETER:'/ucenter/v2/devices/fc226w',
    // 删除表计
    DETELEMETER: `/ucenter/v2/devices/delterminal`,
	//删除直连设备
	DETELEDIRECTLYMETER:'/ucenter/v2/devices/fc226w',
    // 获取未绑定表计
    GETUNBINDINGMETER: `/ucenter/v2/devices/listnobinddev`,
	// 获取未绑定直连设备表计
	GETUNDIRCTLYMETER: `/ucenter/v2/devices/fc226w/unbindhouse`,
    // 表计注册
    BINDINGHOUSE: `/ucenter/v2/devices/edithousedev`,
    // 表计替换
    REPLACEHOUSE: `/ucenter/v2/devices/changehousedev`,
    // 获取项目已绑定的表计列表
    GETBINDINGMETER: `/ucenter/v2/devices/listhousedev`,
    // 解绑
    DELBINDMETER: `/ucenter/v2/devices/delhousedev`,
}

Service.getCollector = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post(_url.GETCOLLECTOR, request, true);
    return Service.handleCommonError(data)
}

// 根据ID获取集控器
Service.getCollectorInfo = async function (params) {
    let request = {}
    // 集控器ID
    request['oid'] = params.OID

    let data = await $post('/ucenter/v2/devices/collector', request, true);
    return Service.handleCommonError(data)
}

Service.addCollector = async function (params) {
    let request = {}
    // // 项目Id
    // request['assigned_project_id'] = Service.getProjectSystemId();
    // if (!request['assigned_project_id']) return;
    // 序列号
    request['deviceserial'] = params.deviceserial;
    // 	设备名
    request['dev_name'] = params.dev_name;
    // 	备注
    request['description'] = params.description;
	
	request['assigned_project_id'] = params.assigned_project_id;
    let data = await $post(_url.ADDCOLLECTOR, request);
    return Service.handleCommonError(data)
}

// 自动添加集控器
Service.addCollectorList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 数组 list[deviceserial]：序列号；list[dev_name]：设备名；list[description]：备注信息；list[ipaddress]：ip地址
    request['list'] = JSON.stringify(params.list);

    let data = await $post('/ucenter/v2/devices/addcollectorlist', request);
    return Service.handleCommonError(data)
}

// 获取未注册的集控器列表
Service.getCollectorList = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/devices/listaddcollector', request);
    return Service.handleCommonError(data)
}

Service.deleteCollector = async function (params) {
    let request = {}
    // 集控器oid
    request['oid'] = params.OID;
    let data = await $post(_url.DETELECOLLECTOR, request);
    return Service.handleCommonError(data)
}

Service.editeCollector = async function (params) {
    let request = {}
    //  集控器ID
    request['oid'] = params.oid;
    // 	设备名
    request['dev_name'] = params.dev_name;
    // 	备注
    request['description'] = params.description;
    // 	序列号
    request['deviceSerial'] = params.deviceSerial;
    // 	新序列号
    request['newDeviceSerial'] = params.newDeviceSerial;

    let data = await $post(_url.EDITCOLLECTOR, request);
    return Service.handleCommonError(data)
}

Service.changeCollector = async function (params) {
    let request = {}
    //  集控器ID
    request['oid'] = params.oid;
    // 	设备名
    request['deviceserial'] = params.newDeviceSerial;

    let data = await $patch('/ucenter/v2/devices/collector/serial', request);
    return Service.handleCommonError(data)
}


Service.getMeter = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    //  集控器ID
    request['oid'] = params.OID;
    //  序列号
    request['deviceserial'] = params.deviceserial;
    //  表记类型
    request['devtype'] = params.devtype;
    //  在线状态（0所有，1在线，2离线
    request['online_status'] = params.online_status;

    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get(_url.GETMETER, request, true);
    return Service.handleCommonError(data)
}

//获取直连设备表计
Service.getDirectlyMeter = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;
	request['device_serial'] = params.deviceserial
	request['online_status'] = params.online_status
	request['page_num'] = params.page_num;
	// 	一页几条数据
	request['page_sum'] = params.page_sum;
    let data = await $get(_url.GETDIRECTLYEMETER, request, true);
    return Service.handleCommonError(data)
}
//获取WEWIBANGDING 直连设备表计
Service.getUndirctlyMeter = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;
	request['device_serial'] = params.deviceserial
	request['online_status'] = params.online_status
	request['page_num'] = params.page_num;
	// 	一页几条数据
	request['page_sum'] = params.page_sum;
    let data = await $get(_url.GETUNDIRCTLYMETER, request, true);
    return Service.handleCommonError(data)
}
Service.addMeter = async function (params) {
    let request = {}
    // 	集控器id
    request['linked_collector_id'] = params.linked_collector_id;
    // 	集控器序列号
    request['collector_serial'] = params.collector_serial;
    // 序列号
    request['deviceserial'] = params.deviceserial;
    // 	表记类型（当量温控器，风机，风柜）
    request['devtype'] = params.devtype;
    // 	表记型号
    request['terminal_base_id'] = params.terminal_base_id;
    // 	风盘风柜型号
    // request['fan_model'] = params.fan_model;
    // 	风盘风柜型号
    request['fan_model_id'] = params.fan_model_id;
    // 	表计名称
    request['customized_serial'] = params.customized_serial;

    let data = await $post(_url.ADDMETER, request);
    return Service.handleCommonError(data)
}

// 添加直连设备
Service.addDirectlyMeter = async function (params) {
    let request = {}
    // 	系统id
    request['project_sys_id'] = Service.getProjectSystemId();
    request['list'] = JSON.stringify(params.list);

    let data = await $post(_url.ADDDIRECTLYMETER, request);
    return Service.handleCommonError(data)
}



// 批量添加
Service.addMeterList = async function (params) {
    let request = {}

    // 	表记数组
    request['terminallist'] = JSON.stringify(params.terminallist);

    let data = await $post("/ucenter/v2/devices/addterminallist", request);
    return Service.handleCommonError(data)
}

// 批量添加
Service.addMeterListAll = async function (params) {
    let request = {}

    // 	表记数组
    request['devtype'] = params.devtype;
    request['terminal_base_id'] = params.terminal_base_id;
    request['collector_serial'] = params.collector_serial;
    request['linked_collector_id'] = params.linked_collector_id;

    let data = await $post("/ucenter/v2/devices/addterminalauto", request);
    return Service.handleCommonError(data)
}
//删除直连设备
Service.deteleDirectlyMeter = async function (params) {
    let request = {}

    // 表记id
	var formData = new FormData();
    formData.append("oid", params.OID);
	let data = await $delete(_url.DETELEDIRECTLYMETER + "", formData, true);
    // let data = await $post(_url.DETELEMETER, request);
    return Service.handleCommonError(data)
}

Service.deteleMeter = async function (params) {
    let request = {}

    // 表记id
    request['oid'] = params.OID;
    
    let data = await $post(_url.DETELEMETER, request);
    return Service.handleCommonError(data)
}

// 编辑表计
Service.editMeter = async function (params) {
    let request = {}
    // 表记id
    request['oid'] = params.oid;
    // 表记类型（1当量温控器，2风柜，3热量表）
    request['devtype'] = params.devtype;
    // 	表记型号
    request['device_model'] = params.device_model;
    // 	表记序列号
    request['deviceserial'] = params.deviceserial;
    // 	风盘风柜型号
    // request['fan_model'] = params.fan_model;
    request['fan_model_id'] = params.fan_model_id;
    // 	集控器序列号
    request['collector_serial'] = params.collector_serial;
    // 	表计名称
    request['customized_serial'] = params.customized_serial;

    let data = await $post('/ucenter/v2/devices/editterminal', request);
    return Service.handleCommonError(data)
}

// 关联设备

Service.assignEdterminal = async function (params) {
    let request = {}

    // 集控器序列号
    request['collector_serial'] = params.collector_serial;
    // 	表记序列号
    request['deviceserial'] = params.deviceserial;
    // 	表记型号
    request['device_model'] = params.device_model;
    // 	风盘风柜型号
    // request['fan_model'] = params.fan_model;
    request['fan_model_id'] = params.fan_model_id;
    // 	表记类型
    request['devtype'] = params.devtype;

    let data = await $post('/ucenter/v2/devices/assignedterminal', request);
    return Service.handleCommonError(data)
}

// 更新集控器下面的表计
Service.upDataMeter = async function (params) {
    let request = {}
    // 	集控器id
    request['linked_collector_id'] = params.linked_collector_id;
    // 	集控器序列号
    request['collector_serial'] = params.collector_serial;

    let data = await $post('/ucenter/v2/devices/addterminalauto', request);
    return Service.handleCommonError(data)
}
//更新直连设备列表
Service.upDataDirectlyMeterList = async function (params) {
    let request = {}
    // 	集控器序列号
    // request['collector_serial'] = params.collector_serial;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get('/ucenter/v2/devices/fc226w/mic', request);
    return Service.handleCommonError(data)
}
Service.upDataMeterList = async function (params) {
    let request = {}
    // 	集控器序列号
    request['collector_serial'] = params.collector_serial;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get('/ucenter/v2/devices/terminalauto', request);
    return Service.handleCommonError(data)
}

Service.getUnbindingMeter = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    //  集控器id
    request['linked_collector_id'] = params.linked_collector_id;
    //  表记类型（1当量温控器，2风柜，3热量表）
    request['devtype'] = params.devtype;

    request['deviceserial'] = params.deviceSerial

    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get(_url.GETUNBINDINGMETER, request, true);
    return Service.handleCommonError(data)
}

Service.meterBindingHouse = async function (params) {
    let request = {}
    // 	房间id
    request['assigned_house_id'] = params.oid;
    // 表记id
    request['terminalid'] = params.terminalid;
    // 	入户抄表值
    request['household_value'] = params.household_value;

    let data = await $post(_url.BINDINGHOUSE, request);
    return Service.handleCommonError(data)
}
// 3-26：改一个房间绑定多个表计
Service.meterBindingHouse2 = async function (params) {
    let request = {}
    // 	房间id
    request['assigned_house_id'] = params.oid;
    // 表记id
    request['terminalidlist'] = JSON.stringify(params.terminalid);

    let data = await $post("/ucenter/v2/devices/edithousedev", request);
    return Service.handleCommonError(data)
}

Service.meterReplaceHouse = async function (params) {
    let request = {}
    // 	房间id
    request['assigned_house_id '] = params.oid;
    // 表记id
    request['oid'] = params.terminalid;

    let data = await $post(_url.REPLACEHOUSE, request);
    return Service.handleCommonError(data)
}

// 6-25改 去掉房间ID
Service.delBindingMeter = async function (params) {
    let request = {}
    // // 	房间id
    // request['oid'] = params.oid;
    // 表记id
    request['oid'] = params.terminalid;

    let data = await $post(_url.DELBINDMETER, request);
    return Service.handleCommonError(data)
}

Service.getBindingMeter = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 建筑ID
    request['moduleid'] = params.moduleid;
	
	//是否是房间
	request['is_house'] = params.is_house;
	//是否是房间
	request['building_index'] = params.buildingindex;
	//是否是房间
	request['page_num'] = params.page_num;
	//是否是房间
	request['page_sum'] = params.page_sum;

    let data = await $post(_url.GETBINDINGMETER, request, true);
    return Service.handleCommonError(data)
}

// 获取风盘
Service.getFancoils = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/base/fancoils', request, true);
    return Service.handleCommonError(data)
}

// 获取风柜
Service.getFancupboard = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/base/fancupboard', request, true);
    return Service.handleCommonError(data)
}

// 添加风盘
Service.addFancoils = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 风盘型号
    request['fancoil_model'] = params.fancoil_model;
    // 风盘电机功率
    request['motor_power'] = params.motor_power;
    // 额定风量
    request['rate_air_amount'] = params.rate_air_amount;
    // 高风挡换热量
    request['high_speed_heat'] = params.high_speed_heat;
    // 中风挡换热量
    request['medium_speed_heat'] = params.medium_speed_heat;
    // 低风挡换热量
    request['low_speed_heat'] = params.low_speed_heat;
    // 地暖换热量
    request['floor_heating'] = params.floor_heating;

    let data = await $post('/ucenter/v2/base/addfancoils', request);
    return Service.handleCommonError(data)
}

// 添加风柜
Service.addFancupboard = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 风柜型号
    request['fancupboard_model'] = params.fancupboard_model;
    // 风柜换热量
    request['cupboard_heat'] = params.cupboard_heat;
    // 电机功率
    request['cupboard_power'] = params.cupboard_power;
    // 备注
    request['description'] = params.description;

    let data = await $post('/ucenter/v2/base/addfancupboard', request);
    return Service.handleCommonError(data)
}

// 修改风盘
Service.editFancoils = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 风盘ID
    request['oid'] = params.OID;
    // 风盘型号
    request['fancoil_model'] = params.fancoil_model;
    // 风盘电机功率
    request['motor_power'] = params.motor_power;
    // 额定风量
    request['rate_air_amount'] = params.rate_air_amount;
    // 高风挡换热量
    request['high_speed_heat'] = params.high_speed_heat;
    // 中风挡换热量
    request['medium_speed_heat'] = params.medium_speed_heat;
    // 低风挡换热量
    request['low_speed_heat'] = params.low_speed_heat;
    // 地暖换热量
    request['floor_heating'] = params.floor_heating;

    let data = await $post('/ucenter/v2/base/editfancoils', request);
    return Service.handleCommonError(data)
}

// 修改风柜
Service.editFancupboard = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    
    // 风柜ID 
    request['oid'] = params.OID;
    // 风柜型号
    request['fancupboard_model'] = params.fancupboard_model;
    // 风柜换热量
    request['cupboard_heat'] = params.cupboard_heat;
    // 电机功率
    request['cupboard_power'] = params.cupboard_power;
    // 备注
    request['description'] = params.description;

    let data = await $post('/ucenter/v2/base/editfancupboard', request);
    return Service.handleCommonError(data)
}

//删除风盘 
Service.delFancoils = async function (params) {
    let request = {}
    // 	风盘id
    request['oid'] = params.OID;

    let data = await $post('/ucenter/v2/base/delfancoils', request);
    return Service.handleCommonError(data)
}

//删除风柜
Service.delFancupboard = async function (params) {
    let request = {}
    // 	风柜id
    request['oid'] = params.OID;

    let data = await $post('/ucenter/v2/base/delfancupboard', request);
    return Service.handleCommonError(data)
}
//根据表计id获取账单
Service.getLastTem = async function (params) {
    let request = {}

    //  表计ID
    request['terminal_id'] = params.terminal_id;

    let data = await $get('/ucenter/v2/base/bill/terminal/lastest', request, true);
    return Service.handleCommonError(data)
}
//根据房间id获取账单
Service.getLastHouse = async function (params) {
    let request = {}

    //  表计ID
    request['house_id'] = params.house_id;

    let data = await $get('/ucenter/v2/base/bill/house/lastest', request, true);
    return Service.handleCommonError(data)
}
//根据用户id获取账单
Service.getLastHold = async function (params) {
    let request = {}
    //  表计ID
    request['household_id'] = params.household_id;

    let data = await $get('/ucenter/v2/base/bill/household/lastest', request, true);
    return Service.handleCommonError(data)
}